export type ReportsType = "tags-report" | "utms-report" | "voice-call-report"

export const reportsTypeToTitle: Record<ReportsType, string> = {
	"tags-report": "Relatório de Tags",
	"utms-report": "Relatório de UTMs",
	"voice-call-report": "Relatório de Ligações"
}
